import {useState, useEffect} from 'react';

const useDelayCallback = () => {
    const [timers, setTimers] = useState<Record<string, number>>({});

    const clearAll = () => {
        Object.values(timers).forEach(timer => clearTimeout(timer));
    };

    useEffect(() => {
        return () => clearAll();
    }, []);

    return {
        clearAll,
        add: (callback: VoidFunction, delayTime = 500, key = 'default') => {
            clearTimeout(timers[key]);
            setTimers({...timers, [key]: setTimeout(callback, delayTime)});
        }
    };
};

export default useDelayCallback;
